import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  SupplierProPurchase,
  SupplierPurchaseFun,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Supplier/SupplierSlice";

import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Purchase({ accountName, accountGroup }) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { SupplierPurchasedata } = useSelector((state) => state.SupplierSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(SupplierPurchaseFun());

    dispatch(
      SupplierProPurchase({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
      }),
    );
  }, [dispatch, Firm, YearId, accountName]);

  const getRows = SupplierPurchasedata?.Data?.map((label, index) => ({
    srNumber: index + 1,
    MonthName: label.MonthName,
    Day01Amt: label.Day01Amt,
    Day02Amt: label.Day02Amt,
    Day03Amt: label.Day03Amt,
    Day04Amt: label.Day04Amt,
    Day05Amt: label.Day05Amt,
    Day06Amt: label.Day06Amt,
    Day07Amt: label.Day07Amt,
    Day08Amt: label.Day08Amt,
    Day09Amt: label.Day09Amt,
    Day10Amt: label.Day10Amt,
    Day11Amt: label.Day11Amt,
    Day12Amt: label.Day12Amt,
    Day13Amt: label.Day13Amt,
    Day14Amt: label.Day14Amt,
    Day15Amt: label.Day15Amt,
    Day16Amt: label.Day16Amt,
    Day17Amt: label.Day17Amt,
    Day18Amt: label.Day18Amt,
    Day19Amt: label.Day19Amt,
    Day20Amt: label.Day20Amt,
    Day21Amt: label.Day21Amt,
    Day22Amt: label.Day22Amt,
    Day23Amt: label.Day23Amt,
    Day24Amt: label.Day24Amt,
    Day25Amt: label.Day25Amt,
    Day26Amt: label.Day26Amt,
    Day27Amt: label.Day27Amt,
    Day28Amt: label.Day28Amt,
    Day29Amt: label.Day29Amt,
    Day30Amt: label.Day30Amt,
    Day31Amt: label.Day31Amt,
    Amount: label.Amount,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Month Name",
      key: "MonthName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Total Amount",
      key: "Amount",
      format: "true",
      align: "right",
    },
    {
      label: "Day 01",
      key: "Day01Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 02",
      key: "Day02Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 03",
      key: "Day03Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 04",
      key: "Day04Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 05",
      key: "Day05Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 06",
      key: "Day06Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 07",
      key: "Day07Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 08",
      key: "Day08Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 09",
      key: "Day09Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 10",
      key: "Day10Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 11",
      key: "Day11Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 12",
      key: "Day12Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 13",
      key: "Day13Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 14",
      key: "Day14Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 15",
      key: "Day15Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 16",
      key: "Day16Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 17",
      key: "Day17Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 18",
      key: "Day18Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 19",
      key: "Day19Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 20",
      key: "Day20Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 21",
      key: "Day21Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 22",
      key: "Day22Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 23",
      key: "Day23Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 24",
      key: "Day24Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 25",
      key: "Day25Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 26",
      key: "Day26Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 27",
      key: "Day27Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 28",
      key: "Day28Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 29",
      key: "Day29Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 30",
      key: "Day30Amt",
      format: "true",
      align: "right",
    },
    {
      label: "Day 31",
      key: "Day31Amt",
      format: "true",
      align: "right",
    },
  ];

  if (SupplierPurchasedata === "no" || SupplierPurchasedata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            PUSRCHASE
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
